import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import ContinueButton from "../../Registration/ContinueButton";
import {
  setServicesAndCapabilities,
  updateServicesAndCapabilities,
} from "../../store/supplierFormDataSlice";

const industries = [
  { code: "11", name: "Agriculture, Forestry, Fishing and Hunting" },
  { code: "21", name: "Mining, Quarrying, and Oil and Gas Extraction" },
  { code: "22", name: "Utilities" },
  { code: "23", name: "Construction" },
  { code: "31-33", name: "Manufacturing" },
  { code: "42", name: "Wholesale Trade" },
  { code: "44-45", name: "Retail Trade" },
  { code: "48-49", name: "Transportation and Warehousing" },
  { code: "51", name: "Information" },
  { code: "52", name: "Finance and Insurance" },
  { code: "53", name: "Real Estate and Rental and Leasing" },
  { code: "54", name: "Professional, Scientific, and Technical Services" },
  { code: "55", name: "Management of Companies and Enterprises" },
  {
    code: "56",
    name: "Administrative and Support and Waste Management and Remediation Services",
  },
  { code: "61", name: "Educational Services" },
  { code: "62", name: "Health Care and Social Assistance" },
  { code: "71", name: "Arts, Entertainment, and Recreation" },
  { code: "72", name: "Accommodation and Food Services" },
  { code: "81", name: "Other Services (except Public Administration)" },
];

const BASE_API_URL =
  "https://api.census.gov/data/2022/ecnbasic?get=NAICS2022,NAICS2022_LABEL,NAME,GEO_ID,ESTAB,RCPTOT,EMP&for=us:*&key=ca9f7d90d4ea4a77f056e0a1ea74f0a8660366b6";

  /*to get industry by providing NAICS code:
  https://api.census.gov/data/2022/ecnbasic?get=NAICS2022,NAICS2022_LABEL&NAICS2022=22111&for=us:*&key=ca9f7d90d4ea4a77f056e0a1ea74f0a8660366b6
  */

const ServicesCapabilitiesForm = ({ onNext }) => {
  const [naicsData, setNaicsData] = useState([]);
  const [primaryNaics, setPrimaryNaics] = useState("");
  const [additionalNaics, setAdditionalNaics] = useState([]);
  const [servicesOffered, setServicesOffered] = useState("");
  const [noDataMessage, setNoDataMessage] = useState("");
  const dispatch = useDispatch();
  const [hasChanges, setHasChanges] = useState(false);
  const userId = useSelector((state) => state.formData.supplierId);
  const servicesAndCapabilities = useSelector(
    (state) => state.formData.servicesAndCapabilities || {}
  );



  const [formData, setFormData] = useState({
    industry: { code: "", name: "" },
    primaryNAICS: { name: "", code: "" },
    additionalNAICS: [],
    servicesOffered: [],
  });
  useEffect(() => {
    if (Object.keys(servicesAndCapabilities).length) {
      setFormData({
        industry: { code: "", name: servicesAndCapabilities.industry || "" }, // Default to empty string
        primaryNAICS: servicesAndCapabilities.primaryNAICS || { name: "", code: "" },
        additionalNAICS: servicesAndCapabilities.additionalNAICS || [],
        servicesOffered: servicesAndCapabilities.servicesOffered || [],
      });

      setPrimaryNaics(servicesAndCapabilities.primaryNAICS?.code || "");
      setAdditionalNaics(
        servicesAndCapabilities.additionalNAICS?.map((naics) => naics.code) || []
      );
      setServicesOffered(servicesAndCapabilities.servicesOffered || []);
    }
  }, [servicesAndCapabilities]);
  
  const isDisabled = !formData.industry.name || !primaryNaics;

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      textAlign: "start",
      background: "#F7F7F7",
    }),
    control: (provided, state) => ({
      ...provided,
      border: "none",
      background: "#F9F9F9",
      textAlign: "start",
      minHeight: "48px",
      height: "auto",
      boxShadow: state.isFocused
        ? "0 0 0 2px rgba(128, 128, 128, 0.5)"
        : provided.boxShadow,
      overflowY: "hidden",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#1D2639",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "lightgray"
        : state.isFocused
        ? "lightgray"
        : provided.backgroundColor,
      color: state.isSelected ? "black" : "black",
      padding: "6px",
      "&:active": {
        backgroundColor: "lightgray",
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#B0B0B0",
    }),
  };

  const customMultiSelectStyles = {
    menu: (provided) => ({
      ...provided,
      textAlign: "start",
      background: "#F7F7F7",
    }),
    control: (provided, state) => ({
      ...provided,
      ...provided,
      border: "none",
      background: "#F9F9F9",
      textAlign: "start",
      minHeight: "48px",
      height: "auto",
      boxShadow: state.isFocused
        ? "0 0 0 2px rgba(128, 128, 128, 0.5)"
        : provided.boxShadow,
      overflowY: "hidden",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#1D2639",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "lightgray"
        : state.isFocused
        ? "lightgray"
        : provided.backgroundColor,
      color: state.isSelected ? "black" : "black",
      padding: "6px",
      "&:active": {
        backgroundColor: "lightgray",
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#B0B0B0",
    }),
  };
  useEffect(() => {
    if (formData.industry.code) {
      const apiUrl = `${BASE_API_URL}&NAICS2022=${formData.industry.code}*`;
      fetch(apiUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          if (data.length > 1) {
            const formattedData = data
              .slice(1)
              .map(([code, description, ...rest]) => ({
                value: code,
                label: `${code} - ${description}`,
                additionalInfo: rest,
              }));
            setNaicsData(formattedData);
            setNoDataMessage("");
          } else {
            setNaicsData([]);
            setNoDataMessage("No NAICS data available.");
          }
        })
        .catch((error) => {
          console.error("Error fetching NAICS data:", error);
          setNoDataMessage("Error fetching NAICS data.");
          setNaicsData([]);
        });
    }
  }, [formData.industry]);

  const handleIndustryChange = (selectedOption) => {
    setHasChanges(true);
    const selectedValue = selectedOption ? selectedOption.value : "";
    const selectedLabel = selectedOption ? selectedOption.label : "";
    setFormData((prev) => ({
      ...prev,
      industry: { code: selectedValue, name: selectedLabel },
      primaryNAICS: { name: "", code: "" },
      additionalNAICS: [],
    }));
    setPrimaryNaics("");
    setAdditionalNaics([]);
    setServicesOffered("");
    setNoDataMessage("");
  };

  const handlePrimaryNaicsChange = (selectedOption) => {
    setHasChanges(true);
    const selectedValue = selectedOption ? selectedOption.value : "";
    setPrimaryNaics(selectedValue);
    const selectedLabel =
      naicsData.find((item) => item.value === selectedValue)?.label || "";
    setServicesOffered(selectedLabel);
    setFormData((prev) => ({
      ...prev,
      primaryNAICS: { name: selectedLabel, code: selectedValue },
    }));
  };

  const handleAdditionalNaicsChange = (selectedOptions) => {
    setHasChanges(true);
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setAdditionalNaics(selectedValues);
    const selectedLabels = selectedOptions
      ? selectedOptions.map((option) => option.label)
      : [];
    setFormData((prev) => ({
      ...prev,
      additionalNAICS: selectedLabels.map((label, index) => ({
        name: label,
        code: selectedValues[index],
      })),
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    onNext();
  
    const serviceInfo = {
      industry: formData.industry.name,
      primaryNAICS: formData.primaryNAICS,
      additionalNAICS: formData.additionalNAICS,
      servicesOffered: formData.servicesOffered,
    };
  
    if (hasChanges) {
      try {
        await dispatch(setServicesAndCapabilities(serviceInfo));
  
        await dispatch(updateServicesAndCapabilities({ id: userId, serviceInfo })).unwrap();
  
      } catch (error) {
        console.error("Failed to update service info:", error);
      }
    }
  };
  
  return (
    <section className="flex flex-col min-h-screen justify-start items-center py-10 px-6">
      <header className="mb-14">
        <h1 className="text-2xl font-semibold text-[#1D2639] text-center">
          Services & Capabilities
        </h1>
        <p className="text-base font-medium text-[#7E7E7E] text-center w-full sm:w-[572px] mt-2">
          Select your industry and specify your services and capabilities. This
          information ensures we match your business with buyers seeking your
          expertise, fostering relevant opportunities and successful
          partnerships.
        </p>
      </header>
      <form
        className="flex flex-col w-full sm:w-[572px]"
        onSubmit={handleSubmit}
      >
        <label className="block text-[#1D2639] text-[12px] text-start font-normal mt-8 mb-2">
          Industry <span className="text-red-500">*</span>
        </label>
        <Select
          options={industries.map(({ code, name }) => ({
            value: code,
            label: name,
          }))}
          value={
            formData.industry.name
              ? { value: formData.industry.code, label: formData.industry.name }
              : ""
          }
          onChange={handleIndustryChange}
          styles={customStyles}
          placeholder="Select an Industry..."
          isClearable
          isSearchable
        />
        <label className="block text-[#1D2639] text-[12px] text-start font-normal mt-8 mb-2">
          Primary NAICS Code <span className="text-red-500">*</span>
        </label>
        <Select
          options={naicsData.map(({ value, label }) => ({ value, label }))}
          value={
            formData.primaryNAICS?.code
              ? {
                  value: formData.primaryNAICS.code,
                  label: formData.primaryNAICS.name,
                }
              : naicsData.find((option) => option.value === primaryNaics) || ""
          }
          onChange={handlePrimaryNaicsChange}
          styles={customStyles}
          placeholder="Select Primary NAICS..."
          isClearable
          isSearchable
        />
        {(primaryNaics || formData.primaryNAICS) && (
          <>
            <label className="block text-[#1D2639] text-[12px] text-start font-normal mt-8 mb-2">
              Additional NAICS Codes
            </label>

            <Select
              options={naicsData.map(({ value, label }) => ({ value, label }))}
              value={
                formData.additionalNAICS?.length
                  ? formData.additionalNAICS.map((naic) => ({
                      value: naic.code,
                      label: naic.name,
                    }))
                  : naicsData.filter((option) =>
                      additionalNaics.includes(option.value)
                    )
              }
              onChange={handleAdditionalNaicsChange}
              styles={customMultiSelectStyles}
              isMulti
              placeholder="Select Additional NAICS Codes..."
            />
          </>
        )}
        <ContinueButton
          label="Save and Continue"
          isDisabled={isDisabled}
          onClick={handleSubmit}
        />
      </form>
    </section>
  );
};

export default ServicesCapabilitiesForm;